import * as React from 'react'
import * as Styled from './List.styles'

const List = ({ type = 'unordered', children, ...props }) => {
  let listTag = 'ul'
  if (type !== 'unordered') {
    listTag = 'ol'
  }

  return (
    <Styled.List
      className={`leshen-list leshen-list${type}`}
      as={listTag}
      {...props}
    >
      {children}
    </Styled.List>
  )
}

export default List
